<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>{{txtSubmenu}} comprobante
          </a>
        </div>
        <div class="col-sm-6 col-6 form__head__boxBtn">
          <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>)</p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-30">
      <div class="card-body">
        <form validate [formGroup]="item" (ngSubmit)="savePaid()">
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <div class="col-12 m-b-10">
                  <span class="badge badge-dark">Esta vista es solo para generar comprobantes electrónicos</span>
                </div>
                <div class="form-group col-lg-6">
                  <label>Tipo Comprobante y serie <span class="required"></span>
                    <span *ngIf="this.typevoucher_factura.id == item.value.typevoucher_id"
                      class="badge badge-warning m-l-10">Debe seleccionar o especificar cliente con N° de RUC</span>
                  </label>
                  <div class="input-group">
                    <select class="form-control" id="typeVoucherSelected" formControlName="typevoucher_id"
                      (change)="changeTypeVoucher()">
                      <option *ngFor="let item of typevouchers" [value]="item.id">{{ item.description }} </option>
                    </select>
                    <span class="input-group-prepend">
                      <span class="input-group-text">SERIE</span>
                    </span>
                    <span class="input-group-prepend">
                      <select class="form-control" id="serieSelected" formControlName="serie">
                        <option *ngFor="let item of series" [value]="item.series">{{ item.series }} </option>
                      </select>
                    </span>
                  </div>
                </div>
                <div class="form-group col-lg-6">
                  <label id="client_label">Cliente <span class="required"></span>
                    <div class="book__nrodoc m-l-20" *ngIf="clientSelected != null">
                      ( {{clientSelected.typeDocument}} : {{clientSelected.document}} )
                    </div>
                  </label>
                  <ng-container *ngIf="clientSelected != null">
                    <div class="input-group">
                      <input type="text" class="form-control form-control-sm" disabled
                        value="{{clientSelected.fullname}}">
                      <div class="input-group-append bg-custom b-0 removeClient">
                        <div class="input-group-text bg-danger w-100 text-center text-white pointer p-l-10"
                          (click)="removeClient()">
                          <i class="fas fa-backspace w-100 f-s-12"></i>
                        </div>
                        <div class="input-group-text bg-info w-100 text-center text-white pointer p-l-10"
                          data-toggle="modal" data-target="#openExtendsClient"
                          (click)="ClientExtendsComponent.editClient(clientSelected.id)">
                          <i class="far fas fa-pen-alt w-100 f-s-12"></i>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                  <ng-container *ngIf="clientSelected == null">
                    <div class="input-group input-group-grid">
                      <component-search-client [classSize]="'search-small'"
                        (selectedClientEvent)="selectedClientSearch($event)" class="w-100">
                      </component-search-client>
                      <div class="input-group-append b-0">
                        <div class="input-group-text w-100 text-center pointer p-l-10" data-toggle="modal"
                          data-target="#openExtendsClient" (click)="ClientExtendsComponent.loadData()">
                          <i class="fas fa-user-plus w-100"></i>
                        </div>
                      </div>
                    </div>
                  </ng-container>
                </div>
                <div class="form-group col-lg-12"
                  *ngIf="clientSelected != null && clientSelected.typedocument_id == typedocument_ruc.id">
                  <label>Dirección Fiscal<span class="required"></span> </label>
                  <input type="text" class="form-control f-s-11" value="{{clientSelected.address}}" disabled>
                </div>
                <div class="form-group col-lg-2">
                  <label>Moneda<span class="required"></span></label>
                  <select class="form-control" formControlName="currency_id" id="currencySelected"
                    (change)="changeCurrency()">
                    <option *ngFor="let item of currencies" [value]="item.id">{{ item.description }} </option>
                  </select>
                </div>

              </div>
              <div class="row m-t-20">
                <div class="col-12">
                  <div class="row">
                    <div class="col-lg-3">
                      <p class="form__group__title f-s-14"> <i class="fa fa-cart-plus m-r-5"></i>Detalle items</p>
                    </div>
                    <div class="col-lg-4">
                      <component-search-product [searchAll]="true" placeholderText="Buscar producto/servicio"
                        (selectedProductEvent)="selectedProductSearch($event)">
                      </component-search-product>
                    </div>
                    <div class="col-lg-3">
                      <button type="button" class="btn btn-sm btn-outline-info f-s-12"
                        (click)="addProductManual()">Producto Manual <i class="fas fa-arrow-circle-down"></i></button>
                    </div>
                  </div>
                </div>
                <div class="col-12">
                  <div class="table-responsive">
                    <table class="table table-hover mb-0">
                      <thead class="thead-default">
                        <tr>
                          <th>Nombre producto</th>
                          <th>Tipo producto</th>
                          <th class="text-centerw-10">Cantidad</th>
                          <th class="text-right w-10">P.V</th>
                          <th class="text-right w-15">Subtotal</th>
                          <th class="text-center"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <ng-container *ngIf="detail_items.length == 0">
                          <tr>
                            <td colspan="4"><span>Aun no se han agregado items</span></td>
                          </tr>
                        </ng-container>
                        <ng-container *ngIf="detail_items.length > 0">
                          <tr *ngFor="let item of detail_items; let index_ = index">
                            <td>
                              <ng-container *ngIf="!item.is_manual">
                                <span>
                                  {{item.description}}
                                </span>
                                <p class="f-s-10 m-b-0 bold">{{item.code}}</p>
                              </ng-container>
                              <ng-container *ngIf="item.is_manual">
                                <textarea id="descriptionProduct{{index_}}"
                                  (keyup)="changeDescription($event.target, index_)"
                                  class="form-control no-resize" rows="2">{{item.description}}</textarea>
                                <!-- <span class="badge badge-info f-s-9">Describir producto manual</span> -->
                              </ng-container>
                            </td>
                            <td class="f-s-12">
                              <ng-container *ngIf="item.is_manual">
                                <select class="form-control sale__inputSelect" id="typeProduct{{index_}}"
                                  (change)="changeTypeProduct($event.target, index_)">
                                </select>
                              </ng-container>
                              <ng-container *ngIf="!item.is_manual">
                                {{item.typeProductName}}
                              </ng-container>
                            </td>
                            <td class="nowrap w-10">
                              <input type="text" id="quantity{{index_}}" class="form-control sale__input text-center"
                                value="{{item.quantity}}" (keyup)="changeQuantity($event.target, index_)" numeric
                                onclick="click_input(this)">
                            </td>
                            <td class="nowrap w-10">
                              <input type="text" id="price{{index_}}" class="form-control sale__input text-right"
                                value="{{item.price}}" (keyup)="changePrice($event.target, index_)" numeric decimals="2"
                                onclick="click_input(this)">
                            </td>
                            <td class="nowrap w-15">
                              <input type="text" id="subtotal{{index_}}" class="form-control sale__input text-right"
                                value="{{item.subtotal}}" numeric decimals="2" disabled>
                            </td>
                            <td class="text-center">
                              <i class="far fa-trash-alt book__trash" (click)="removeProduct(item.id, index_)"></i>
                            </td>
                          </tr>
                        </ng-container>
                      </tbody>
                      <tfoot>
                        <tr class="text-primary">
                          <td class="text-right f-s-15" colspan="4">
                            <span class="bold"> TOTAL</span>
                          </td>
                          <td class="text-right f-s-15">
                            <span class="bold">{{currencySelected.symbol}}{{total_amount}}</span>
                          </td>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
              <div class="row m-t-20">
                <div class="col-12">
                  <div class="row">
                    <div class="col-lg-12">
                      <p class="form__group__title f-s-14"> <i class="fa fa-money-bill m-r-5"></i>Detalle pago</p>
                    </div>
                  </div>
                </div>
                <div class="col-lg-12" *ngIf="validatealert">
                  <ng-container *ngIf="moneybox != null">
                    <ng-container *ngIf="moneybox.status_closed == true || moneybox.is_before">
                      <div class="alert alert-danger alert-dismissible fade show" role="alert">
                        Debe corregir el estado de la caja para realizar movimientos de dinero,
                      </div>
                    </ng-container>
                  </ng-container>
                  <ng-container *ngIf="!check_moneybox">
                    <div class="alert alert-danger alert-dismissible fade show" role="alert">
                      Debe aperturar la caja para realizar movimientos de dinero,
                    </div>
                  </ng-container>
                </div>

                <div class="form-group col-lg-4">
                  <label>Condición pago<span class="required"></span></label>
                  <select class="form-control" formControlName="typetransaction_id" id="transactionSelected"
                    (change)="changeTypeTransaction()">
                    <option *ngFor="let item of transactions" [value]="item.id">{{ item.description }} </option>
                  </select>
                </div>
                <ng-container *ngIf="transactionSelected == transaction_cash">
                  <div class="form-group col-lg-3" *ngIf="boxselected != null">
                    <label>
                      Caja seleccionada
                      <span class="required"></span>
                    </label>
                    <input type="text" disabled value="{{boxselected.description}}" class="form-control">
                    <ng-container *ngIf="check_moneybox">
                      <ng-container *ngIf="moneybox.is_before">
                        <span class="badge badge-warning f-s-11" ng-if="moneybox.is_before">CONTINÚA EN FECHA ANTERIOR
                          :
                          {{moneybox.date_opening}}</span>
                      </ng-container>
                    </ng-container>
                  </div>
                  <div class="form-group col-lg-3">
                    <label>Método de pago <span class="required"></span></label>
                    <select class="form-control" id="paymentSelected" formControlName="paymentmethod_id"
                      (change)="changePaymentMethod()" required>
                      <option *ngFor="let item of paymentmethods" [value]="item.id">{{ item.description }}</option>
                    </select>
                  </div>
                  <ng-container *ngIf="paymentMethodSelected.associate_bank">
                    <div class="form-group col-lg-6">
                      <label>Cuenta destino
                        <span class="f-s-9" *ngIf="accountbanks.length == 0">( 0 registros )</span>
                      </label>
                      <ng-container *ngIf="accountbanks.length == 0">
                        <a type="button" class="btn btn-outline-info text-white"
                          routerLink="/{{branchofficeSlug}}/finanzas/cuentas_bancarias/lista">
                          <i class="fas fa-arrow-right m-r-5"></i>Agregar Cuenta
                        </a>
                      </ng-container>
                      <ng-container *ngIf="accountbanks.length > 0">
                        <select class="form-control" id="bankAccountSelected"
                          (change)="changeBankAccount($event.target)">
                          <option *ngIf="!isEdit" value="null">Seleccionar cuenta</option>
                          <option *ngFor="let item of accountbanks" [value]="item.id">{{ item.concat_description}}
                          </option>
                        </select>
                      </ng-container>
                    </div>
                    <div class="form-group col-lg-3">
                      <label>N° operación</label>
                      <input type="text" class="form-control" formControlName="reference_operation">
                    </div>
                  </ng-container>
                  <div class="form-group col-lg-6">
                    <label>Adjuntar constancia</label>
                    <input id="fileUrlImage" type="file" accept="image/png, image/jpeg, image/jpg"
                      (change)="onFileSelected($event)">
                  </div>
                </ng-container>
                <ng-container *ngIf="transactionSelected == transaction_credit">
                  <div class="form-group col-lg-5">
                    <label>Fecha de vencimiento (30 días calendario)</label>
                    <input type="date" id="date_expiration" class="form-control" formControlName="date_expiration">
                  </div>
                </ng-container>

                <ng-container *ngIf="transactionSelected == transaction_credit_parts">
                  <div class="form-group col-lg-2">
                    <label>.</label>
                    <a class="btn btn-info btn-sm" (click)="addDetailCreditPart()">Agregar Cuota <i
                        class="fas fa-arrow-down m-l-5"></i> </a>
                  </div>
                  <div class="row col-lg-12">
                    <div class="col-lg-6">
                      <div class="tabla-responsive">
                        <table class="table mb-0 table-hover">
                          <thead class="thead-default">
                            <tr>
                              <th>N° Cuota</th>
                              <th>Fecha</th>
                              <th>Monto</th>
                            </tr>
                          </thead>
                          <tbody>
                            <ng-container *ngFor="let item of detail_credit_parts; let index_ = index">
                              <tr>
                                <td>
                                  {{index_+1}}
                                </td>
                                <td>
                                  <input type="text" class="form-control text-center sale__input f-s-12"
                                  id="date_assigned{{index_}}" value="{{item.date_assigned}}">
                                </td>
                                <td>
                                  <input type="text" id="amount_assigned{{index_}}"
                                          class="form-control form-control-xs text-center"
                                          value="{{item.amount_assigned}}"
                                          (keyup)="changeAmountCreditPart($event.target, index_)" numeric decimals="2"
                                          onclick="click_input(this)">
                                </td>
                                <td>
                                  <i class="far fa-trash-alt pointer f-s-15 text-danger"
                                    (click)="removeCreditPart(item.id, index_)"></i>
                                </td>
                              </tr>
                            </ng-container>
                          </tbody>
                        </table>
                      </div>
                    </div>

                  </div>
                </ng-container>


              </div>
            </div>
            <div class="form-group col-lg-12 form__footerBtn">
              <div class="text-right">
                <a class="btn btn-secondary text-white" (click)="cancel()">Cancelar</a>
                <button type="submit" class="btn btn-primary" [disabled]="item.invalid">
                  <i class="far fa-save m-r-5"></i>
                  Emitir Comprobante
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
<app-client-extends (onSubmitEvent)="extendsClient($event)"></app-client-extends>
